/*
 * File: paymentMethod.interface.ts
 * Project: meki
 * File Created: Monday, 5th October 2020 4:53:04 pm
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Thursday, 20th October 2022 12:07:53 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import { StoreObject } from '@apollo/client';
import { User } from '@interfaces';

export enum OtherPaymentMethods {
  FINTOC = 'Fintoc',
  BANCO_ESTADO = 'BancoEstado',
}
export interface PaymentMethod extends StoreObject {
  id: number;
  uuid: string;
  type: string;
  data: PaymentMethodDataOneClick | Record<string, string | number>;
  user: User;
}

export interface PaymentMethodDataOneClick {
  tbkUser: string;
  username: string;
  responseCode: number;
  creditCardType: string;
  last4CardDigits: string;
}

export function isPaymentMethodDataOneClick(
  data: unknown,
): data is PaymentMethodDataOneClick {
  return typeof data === 'object' && data !== null && 'tbkUser' in data;
}
